import { Injectable } from '@angular/core';
import { QuotesDetailsApi } from '@design/api/quotes-details-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { catchError, exhaustMap, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { fromInverterActions, fromInverterSelectors } from '.';
import { DesignState } from '../design.reducer';
import { Store, select } from '@ngrx/store';
import { fromMetaDataActions, fromMetaDataSelectors } from '../meta-data';
import { of } from 'rxjs';
import { fromAdditionalToolsActions, fromAdditionalToolsResultsSelectors } from '../additional-tools';
import { SaveStatus } from '@design/models/save-status.model';


@Injectable()
export class InverterEffects {

  removeKeyFromArray = (array: any[], keyToRemove: string) => {
    return array.map(obj => {
      const { [keyToRemove]: _, ...rest } = obj;
      return rest;
    });
  }

  triggerSaveInverter$ = createEffect(() =>

    this.actions$.pipe(
      ofType(fromInverterActions.AddInverter, fromInverterActions.UpdateInverter, fromInverterActions.DeleteInverter),
      mergeMap((type) => [
        fromAdditionalToolsActions.setHardwareAPIStatus({ setHardwareAPIStatus: SaveStatus.INPROGRESS }),
        fromInverterActions.SaveInverters()
      ]
      )
    )
  );

  saveInveters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInverterActions.SaveInverters,fromInverterActions.UpdateDcAcRatio,fromInverterActions.UpdateEfficiency),
      concatLatestFrom(() => [this.store.select(fromInverterSelectors.inverterSelector), this.store.select(fromInverterSelectors.allInverters), this.store.select(fromAdditionalToolsResultsSelectors.getSelectedMonitoringSystemSelector), this.store.select(fromMetaDataSelectors.quoteMonitoringSystem)]),
      mergeMap(([state, selectedInverter, allInverters, energy, quoteMonitoringSystem]) => {

        let updatedHardware = {};
        if (allInverters.length > 0) {

          updatedHardware = {
            dcAcRatio: selectedInverter?.dcAcRatio,
            efficiency: selectedInverter?.efficiency,
            addedCapacity: selectedInverter?.addedCapacity,
            configured: this.removeKeyFromArray(allInverters, 'id')
          };
          if (energy?.monitoringModelName) {
            updatedHardware = { ...updatedHardware, monitoringSystem: { name: quoteMonitoringSystem?.name ? quoteMonitoringSystem?.name : energy?.monitoringModelName } }
          }
        }

        return this.quotes.updateQuoteHardware({ inverter: updatedHardware }).pipe(
          map((hardware: any) => {
            this.store.dispatch(fromAdditionalToolsActions.setHardwareAPIStatus({setHardwareAPIStatus: SaveStatus.SAVED}));
            return fromMetaDataActions.SaveInvertersSuccess({ inverter: hardware.inverter })
          },
            catchError((error) => {
              this.store.dispatch(fromAdditionalToolsActions.setHardwareAPIStatus({setHardwareAPIStatus: SaveStatus.FAILED}));
              return of(fromMetaDataActions.SaveInvertersFailure({ error }))
            }))
        );

      })
    )
  );


  constructor(private actions$: Actions, private store: Store<DesignState>, private quotes: QuotesDetailsApi) {}



}
